<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_v"></a><em class="italic">In memory of my own aunt Dorothy,<br/>and of my grandmother Margery</em></p>
<p class="imagex"><img alt="Image" class="img1" src="images/flower.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?26d4f950